<router-outlet></router-outlet>
<app-alert-bar></app-alert-bar>
<ngx-ui-loader></ngx-ui-loader>
<app-confirmation-bar></app-confirmation-bar>